import { AppLayout } from "@/components/layout/AppLayout";
import { BillingGlobalSettings } from "./BillingGlobalSettings";
import { PlansSection } from "./PlansSection";
import { FeaturesCatalogSection } from "./FeaturesCatalogSection";

export const PlanSettingsPage = () => {
  return (
    <AppLayout title="Plan Settings">
      <div className="space-y-5">
        <BillingGlobalSettings />
        <PlansSection />
        <FeaturesCatalogSection />
      </div>
    </AppLayout>
  );
};

export default PlanSettingsPage;
